<template>
  <div class="flex justify-center p-5">
    <i class="fa-solid fa-spinner animate-spin text-2xl text-neutral700"></i>
  </div>
</template>
